import React from "react"
import { CompanyDto, AccountData } from "../../generated";
import { attach } from "../../common/componentExtensions";
import Store from "../../login/loginStore";
import esercentiActions from "../../login/esercentiActions";
import { canRequireUser } from "../../login/loginHelpers";
import DatesHelper from "../../common/datesHelper";
import { Link } from "../../common/components/link";
import { links } from "../../routes";

interface Props {
    company: CompanyDto | null
    user: AccountData | null
}
class __SdiPecRequiredAlert extends React.Component<Props>{
    componentDidMount() {
        if (Store.getEsercente() == null)
            esercentiActions.getEsercente();
    }

    render() {
        const { company, user } = this.props;
        if (user == null || company == null || user.expiration.valueOf() < DatesHelper.AddDays(new Date(), 15).valueOf() || company.sdi || company.pec)
            return null;

        return (<div className="col-12">
            <div className="card">
                <div className="card-body">
                    <div className="alert alert-danger">
                        <div className="text-center">
                            <i className="fas fa-exclamation-triangle fa-3x" />
                            <h2>DATI FATTURAZIONE RICHIESTI</h2>
                        </div>
                        <div>Ai fini della fatturazione elettronica è necessario completare la propria anagrafica inserendo il tuo Codice univoco e la tua pec.</div>
                    </div>
                    <Link to={links.companyEdit} className="btn btn-danger w-100 btn-lg pulse">Aggiorna i tuoi dati</Link>
                </div>
            </div>
        </div>
        )
    }
}

export default canRequireUser(attach(__SdiPecRequiredAlert, Store, (store, props) => ({ company: store.getEsercente() })));